$(document).ready(function() {
    let isLast = false;
    if ($('span#infinite-scroll').length > 0) {
        const $grid = $('.grid').masonry({ itemSelector: '.grid-item', columnWidth: 352, horizontalOrder: true });
        $grid.infiniteScroll({
            path     : 'a#next_url',
            append   : 'span#infinite-scroll',
            outlayer : $grid.data('masonry'),
            hideNav  : 'a#next_url',
            history  : false
        });
        $grid.data('infiniteScroll').on('append', function () {
            dsProduct.loadPage('append');
            dsUtilities.loadMoreMenu();
            dsSEO.gtmProductImpression($('span#infinite-scroll').length);
            if (isLast) {
                $('div#load_more').removeClass('hide');
            }
        }).on('last', function () {
            isLast = true;
        });
    }
});